import { render } from "./PosterSection.vue?vue&type=template&id=322aa824&scoped=true"
import script from "./PosterSection.vue?vue&type=script&lang=js"
export * from "./PosterSection.vue?vue&type=script&lang=js"

import "./PosterSection.vue?vue&type=style&index=0&id=322aa824&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322aa824"]])

export default __exports__